import { useMemo } from "react";

import packageInfo from "../../package.json";

const usePackageVersion = (): string =>
  useMemo(() => packageInfo.version ?? "0.0.0", []);

export default usePackageVersion;
